/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description Description Field
 */
import { Button, Flex, Tag } from 'antd';
import { Input } from 'antd/lib';

const TAGS = ['Copayment', 'Coinsurance', 'Deductible', 'Self-Pay', 'Non-Covered Service'];

const DescriptionField: React.FC<{ value?: string; onChange: (value: string) => void }> = ({ value, onChange }) => {
	return (
		<>
			<Input.TextArea
				placeholder='Write a brief description of the payment'
				rows={2}
				value={value}
				onChange={(e) => onChange(e.target.value)}
			/>
			<Flex>
				{TAGS.map((tag) => (
					<Button
						type='link'
						key={tag}
						className='m-0 p-0'
						onClick={() => {
							onChange((value || '') + tag + ' ');
						}}
					>
						<Tag key={tag} color='purple'>
							{tag}
						</Tag>
					</Button>
				))}
			</Flex>
		</>
	);
};

export default DescriptionField;
